/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_3_TitleInputs */

const es_home_usecases_item_3_title = /** @type {(inputs: Home_Usecases_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de Conocimiento Onboarding`)
};

const en_home_usecases_item_3_title = /** @type {(inputs: Home_Usecases_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding Knowledge Management`)
};

/**
* | output |
* | --- |
* | "Onboarding Knowledge Management" |
*
* @param {Home_Usecases_Item_3_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_3_title = /** @type {((inputs?: Home_Usecases_Item_3_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_3_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_3_title(inputs)
	return en_home_usecases_item_3_title(inputs)
});
export { home_usecases_item_3_title as "home.usecases.item_3_title" }